import React, { useState } from "react";
import classnames from "classnames";
import css from './NestedMenu.module.css';
import Icon from '@mdi/react';
import { mdiChevronRight } from "@mdi/js";

const NestedMenu = ({ items, children }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const renderMenu = (items, parentKey = "") => (
    <ul className={classnames(css.menu, { [css.rootMenu]: !parentKey })}>
      {items.map((item, index) => {
        const key = `${parentKey}${index}`;
        const hasSubMenu = Array.isArray(item.subMenu);
        return (
          <a
            href={item.link}
            className={css.link}
          >
            <li
              key={key}
              className={classnames(css.item, { [css.hasSubMenu]: hasSubMenu })}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className={css.itemContent}>
                {item.title}
                {hasSubMenu && <span className={css.caret}>
                  <Icon path={mdiChevronRight} size={1}
                    color="black"
                  />
                </span>}
              </div>
              {hasSubMenu && (
                <div className={css.subMenuWrapper}>
                  {renderMenu(item.subMenu, `${key}-`)}
                </div>
              )}
            </li>
          </a>
        );
      })}
    </ul>
  );

  return (
    <div className={classnames(css.container, { [css.hovered]: isHovered })}>
      <div className={css.headerWrapper}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children && <div className={css.header}>{children}</div>}
        <div className={css.mainMenu}>{renderMenu(items)}</div>
      </div>
    </div>
  );
};

export default NestedMenu;
